import featureCover1 from "./feature-project-1.webp"
import featureCover2 from "./feature-project-2.webp"

export const expertiseDetails = ['Frontend Development', 'UI & UX Design', 'Responsive Web Design', 'Cross-Browser Compatibility', 'Site Troubleshooting', 'Performance optimization'];

export const skillDetails = [
    {
        label: "HTML5",
        value: 95,
        ariaLabel: "html"
    },
    {
        label: "CSS & Preprocessors",
        value: 90,
        ariaLabel: "css"
    },
    {
        label: "Javascript & Frameworks",
        value: 75,
        ariaLabel: "javascript"
    },
    {
        label: "CSS Frameworks",
        value: 80,
        ariaLabel: "css frameworks"
    },
    {
        label: "UX & UI Design",
        value: 95,
        ariaLabel: "UI Design"
    },
    {
        label: "Git",
        value: 80,
        ariaLabel: "git"
    },
];

export const educationDetails = [
    {
        head: "Bachelor of Computer Applications",
        subHead: "Panjab University",
        tag: "2017 - 2020"
    },
    {
        head: "Developer Virtual Experience Program",
        headLink: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Accenture%20Nordics/PxenP4rHNE6Bh4nQz_Accenture%20Nordics_FTz3DdCfP3AqEYDpG_1673691863221_completion_certificate.pdf",
        subHead: "Accenture Nordics - Forage",
        tag: "Jan 2023"
    },
    {
        head: "Agile Virtual Experience Program",
        headLink: "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/JPMorgan%20Chase%20%26%20Co./5QiaMtZ4k8ngYKn4D_JPMorgan%20Chase%20%26%20Co._FTz3DdCfP3AqEYDpG_1687531989001_completion_certificate.pdf",
        subHead: "JPMorgan Chase & Co. - Forage",
        tag: "Jun 2023"
    }
];

export const techStackDetails = ['HTML', 'HTML5', 'CSS', 'CSS3', 'CSS FLEX', 'Flexbox', 'CSS GRID', 'SASS', 'SCSS', 'JavaScript', 'TypeScript', 'jQuery', 'Bootstrap', 'Tailwind CSS', 'Figma', 'XD', 'Git', 'Github', 'React', 'Angular', 'Razor UI', 'Asp.Net', 'Adobe Target', 'Agile', 'Scrum', 'DOM manipulation', 'Responsive web design', 'Web Accessibility (WCAG)', 'Cross-browser compatibility', 'Site troubleshooting', 'Performance optimization'];

export const experienceDetails = [
    {
        head: "Software Engineer",
        subHead: "BLJ Tech Geeks",
        tag: "2024 - Present",
        roles: ["Developed robust web-client user interfaces by leveraging coding and design expertise.", "Improved UI performance and usability through efficient component architecture and code optimization.", "Ensured consistency with design systems while maintaining accessibility and cross-browser compatibility."]
    },
    {
        head: "Frontend Developer",
        subHead: "Sandvok Softwares",
        tag: "2021 - 2024",
        roles: ["Developed and maintained responsive web applications using React, Angular, JavaScript, and TypeScript." ,"Implemented modular frontend architecture to improve application scalability and maintainability.", "Conducted code reviews and enforced best practices to maintain high code quality standards.", "Collaborated with UX teams to refine user flows and improve user engagement.", "Diagnosed and resolved UI issues to enhance performance and user experience."]
    }
];

export const featureProjectsDetails = [
    {
        title: "The Shade Home",
        summary: "This redesign project aims to not only enhance the visual appeal of the website but also to improve user engagement through a responsive and user-friendly design.",
        stack: ["HTML5", "CSS3", "JavaScript", "Bootstrap", "jQuery"],
        links: {
            live: "https://theshadehome.com/",
            code: "#"
        },
        coverImg: featureCover1
    }
];

export const projectsDetails = [
    {
        title: "Radancy",
        summary: "Developed and maintained enterprise career websites on the Radancy platform, implementing responsive, accessible, and high-performance UI components with WCAG-compliant design.",
        stack: ["HTML5", "CSS3", "SASS", "JavaScript", "jQuery", "WCAG"],
        links: {
            live: "#",
            code: "#"
        }
    },
    {
        title: "Good Furs",
        summary: "Developed responsive, pixel-perfect UI components using HTML5, CSS3, JavaScript, and modern frontend frameworks, translating Figma designs into reusable components to improve maintainability and development efficiency.",
        stack: ["HTML5", "CSS3", "React", "Tailwind CSS" ],
        links: {
            live: "https://goodfurs.in/",
            code: "#"
        }
    }
];

export const contactDetails = [
    {
        title: "Email Me",
        icon: "envelope",
        cardContent: {
            label: "ipiyushchaudhary@gmail.com",
            url: "mailto:ipiyushchaudhary@gmail.com"
        }        
    },
    {
        title: "Call Me",
        icon: "telephone",
        cardContent: {
            label: "+91-79868-16987",
            url: "tel:+7986816987"
        }        
    },
    {
        title: "My Address",
        icon: "geo-alt",
        cardContent: {
            label: "Ludhiana, Punjab, IN 141001"
        }        
    },
    {
        title: "Social Profiles",
        icon: "share"        
    }
];
